import { React, useEffect, useState } from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { useHistory, useLocation } from "react-router-dom";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LoaderScreen } from "../../components/LoaderScreen";
import Swal from "sweetalert2";
import request from "../../../Helpers/API";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { ModalCargarConvenioPago } from "./Modales/ModalCargarConvenioPago";
import { ModalDescargaArchivos } from "./Modales/ModalDescargaArchivos";
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { Select } from "@mui/material";
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from "@mui/icons-material/Save";
import { ModalGuardarDatosContacto } from "./Modales/ModalGuardarDatosContacto";
import { ModalEditarDatosContacto } from "./Modales/ModalEditarDatosContacto";
import { ModalComentarios } from "./Modales/ModalComentarios";
import CommentIcon from '@mui/icons-material/Comment';

export const DatosContactoScreen = () => {
    const history = useHistory();
    const { state } = useLocation();
    const [clientes, setClientes] = useState([]);
    const [contacto, setContacto] = useState([]);
    const [responsable, setResponsable] = useState([]);
    const [selectedContacto, setSelectedContacto] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [openModalComentarios, setOpenModalComentarios] = useState(false);
    const [openModalEditar, setOpenModalEditar] = useState(false);
    const [modalDescarga, setModalDescarga] = useState(false);
    const [options, setOptions] = useState([]);
    const [selectedOption, setSelectedOption] = useState('');
    const [comentarios, setComentarios] = useState([]);
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });
    const [recarga, setRecarga] = useState(false);

    const handleOpenModal = (idcliente) => {
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
        cargarContactos();
    };

    const handleOpenModalComentarios = (idcliente) => {
        setOpenModalComentarios(true);
    };

    const handleCloseModalComentarios = () => {
        setOpenModalComentarios(false);
    };

    const handleOpenModalEditar = (contacto) => {
        setOpenModalEditar(true);
        setSelectedContacto(contacto);
    };

    const handleCloseModalEditar = () => {
        setOpenModalEditar(false);
        cargarContactos();
    };

    useEffect(() => {
        request
            .get(`ResponsablesCobranzaMostrar/Obtener_Responsables`)
            .then((result) => {
                setOptions(result);
            })
            .catch((error) => {
                console.error("Error fetching select options:", error);
            });
    }, []);

    const cargarContactos = () => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(`ClientesDatosContactoBuscar/MostrarDatosContacto?idcliente=${state.idcliente}`)
            .then((result) => {
                setContacto(result);
                setLoader({ ...loader, mostrar: false });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("CONVENIO DE PAGO", JSON.stringify(error), "error");
            });
    };

    console.log(contacto)

    useEffect(() => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(`ClientesDatosContactoBuscar/MostrarDatosContacto?idcliente=${state.idcliente}`)
            .then((result) => {
                setContacto(result);
                setLoader({ ...loader, mostrar: false });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("CONVENIO DE PAGO", JSON.stringify(error), "error");
            });
    }, [state.idcliente, recarga]);
    const onGuardar = () => {
        setLoader({ ...loader, mostrar: true });
        const mdl = {
            idcliente: state.idcliente,
            idusuario: selectedOption,
            usuario: 0
        };
        request
            .post(`ClientesResponsableCobranza/Guardar`, mdl)
            .then(response => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire({
                    title: 'Éxito',
                    text: 'Los datos se han guardado correctamente.',
                    icon: 'success',
                    confirmButtonText: 'Aceptar'
                });
            })
            .catch((error) => {
                console.log(error);
                setLoader({ ...loader, mostrar: false });
            });
    };

    useEffect(() => {
        request
            .get(`ResponsableCobranzaporCliente/ObtenerResponsable?idcliente=${state.idcliente}`)
            .then((result) => {
                setResponsable(result);
            })
            .catch((error) => {
                Swal.fire("CONVENIO DE PAGO", JSON.stringify(error), "error");
            });

    }, [state.idcliente]);

    // useEffect(() => {
    //     request
    //         .get(`ComentariosClientesContacto/Mostrar?idcliente=${state.idcliente}`)
    //         .then((result) => {
    //             setComentarios(result);
    //             console.log(comentarios)
    //         })
    //         .catch((error) => {
    //             Swal.fire("CONVENIO DE PAGO", JSON.stringify(error), "error");
    //         });

    // }, [state.idcliente]);

    useEffect(() => {
        if (responsable && responsable[0] && responsable[0].idusuario) {
            setSelectedOption(responsable[0].idusuario);
        } else {
            setSelectedOption('');
        }
    }, [responsable]);

    const obtenerMedioContacto = (medio) => {
        if (medio === 'w' || medio === 'W') {
            return 'WhatsApp';
        } else if (medio === 't' || medio === 'T') {
            return 'Teléfono';
        } else if (medio === 'c' || medio === 'C') {
            return 'Correo';
        } else if (medio === 'p' || medio === 'P') {
            return 'Pagina web';
        } else {
            return medio;
        }
    };

    return (
        <PlantillaScreen
            titulo={`${state.razonsocial}`}
            className={"datos-contacto-main-screen"}
            className_main={1}
        >
            <div className="listado-datos-contacto">
                <LoaderScreen loader={loader} />
                <div className="listado-datos-contacto-header">
                    <div className="listado-datos-contacto-header-title">
                        <FormControl fullWidth>
                            <InputLabel id="select-responsable-cobranza-label">Responsable de cobranza</InputLabel>
                            <Select
                                labelId="select-responsable-cobranza-label"
                                id="select-responsable-cobranza"
                                className="select-responsable"
                                value={selectedOption}
                                onChange={(e) => setSelectedOption(e.target.value)}
                                label="Responsable de cobranza"
                            >
                                {options.map((option) => (
                                    <MenuItem key={option.idusuario} value={option.idusuario}>
                                        {option.idusuario} - {option.responsable_cobranza}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>
                </div>
                <div className="listado-datos-contacto-container scroll-4">
                    <table>
                        <thead>
                            <tr>
                                <th>Medio de Contacto</th>
                                <th>
                                    <div>Valor</div>
                                </th>
                                <th>
                                    <div>
                                        <div
                                            className="listado-datos-contacto-header-agregar-contacto"
                                            onClick={() => handleOpenModal(state.idcliente)}
                                        >
                                            <PersonAddIcon /> Registrar Contacto
                                        </div>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {contacto.map((contacto) => (
                                <tr key={contacto.idmedio}>
                                    <td className="medio-contacto-celda ta-center">{obtenerMedioContacto(contacto.medio_contacto.trim())}</td>
                                    <td className="valor-celda ta-center">{contacto.medio}</td>
                                    <td className="button-celda">
                                        <div className="datos-contacto-editar-button">
                                            <div className="datos-contacto-editar" onClick={() => handleOpenModalEditar(contacto)}>
                                                <EditIcon /> Editar
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <ModalGuardarDatosContacto open={openModal} handleCloseModal={handleCloseModal} idcliente={state.idcliente} />
                <ModalEditarDatosContacto open={openModalEditar} handleCloseModalEditar={handleCloseModalEditar} idcliente={state.idcliente} contactos={selectedContacto} />
                <ModalComentarios open={openModalComentarios} handleCloseModal={handleCloseModalComentarios} idcliente={state.idcliente} />
                <div className="listado-datos-contacto-footer">
                    <div
                        className="listado-datos-contacto-footer-back"
                        onClick={() =>
                            history.push("/Creditoycobranza/ConvenioPago")
                        }
                    >
                        <ArrowBackIcon /> Regresar
                    </div>
                    <div
                        className="listado-datos-contacto-footer-comentarios"
                        onClick={() => handleOpenModalComentarios()}
                    >
                        <CommentIcon /> Comentarios
                    </div>
                    <div
                        className="listado-datos-contacto-footer-guardar"
                        onClick={() => onGuardar()}
                    >
                        <SaveIcon /> Guardar
                    </div>
                </div>
            </div>
        </PlantillaScreen>
    );
};
